export default __webpack_public_path__ + "static/btc-7c6b97d45ac19501987706e08de3ef87.png";